<div class="main-background h-100 m-0 p-0" [style.background]="'url(' + imgService.getImage('background.png') + ')'">
  <splash-screen></splash-screen>
  <router-outlet></router-outlet>
</div>